export default __webpack_public_path__ + "static/media/24.12692cd2.png";